class Api {
  
    
    
    constructor(apiUrl) {
      this.url = apiUrl;
    }
    
    send(
      uri,
      json, 
      successCallback, 
      errorCallback
    ) {
      $.ajax({
             url: this.url + uri,
             type: "post",
             data: json ,
             success: function (response) {
                successCallback(response);
             },
             error: function(jqXHR, textStatus, errorThrown) {
                errorCallback(jqXHR, textStatus, errorThrown);
             }
         });
    }
    
  }
  export default Api;
  


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/js/api/api.js
// module id = 324
// module chunks = 4